<template>
	<v-popover
		placement="top"
		trigger="manual"
		:autoHide="false"
		:open="isShowing"
		offset="15"
	>
		<slot name="component"></slot>
		<template slot="popover">
			<transition name="fade" type="transition" @after-enter="addTooltipListener">
				<component
					v-if="isShowing"
					:is="tooltipComponent"
					@closed="hideTooltip"
				/>
			</transition>
		</template>
	</v-popover>
</template>

<script>
import tooltips from '@/mixins/tooltips';

export default {
	name: 'TutorialInterfaceItem',
	mixins: [tooltips],
	props: {
		isShowing: false,
	},
	computed: {
		tooltipComponent() {
			return {
				template:
				`<div>
					<div class="cover" @click="$emit('closed')"></div>
					${this.tooltipMessage}
					<button class="close-btn" @click="$emit('closed')">&times;</button>
				</div>`,
			};
		},
	},
	watch: {
		tooltipLocation(newLocation, oldLocation) {
			if (newLocation !== oldLocation && this.isShowing) {
				this.showTooltip();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.v-popover /deep/ .trigger {
		display: block !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialInterfaceItem.vue